import { AxiosResponse } from 'axios';

import { UDNICK } from 'service/udnick';
import { ICidadeSelecionada } from 'store/ducks/estadoCidade/types';

export const CriaTransportadora = {
  criaTransportadora: (
    parceiros: number[] | undefined,
    nome: string | number | undefined,
    cnpj: string | number | undefined,
    codCid: ICidadeSelecionada | undefined | any
  ): Promise<AxiosResponse> =>
    UDNICK.callService('criaTransportadora', { parceiros, nome, cnpj, codCid }),
};
